export default "__VITE_ASSET__84e73778__"